export default {
    searchFilterText: {
        fr: 'Rechercher un médecin par nom ou spécialité...',
        en: 'Find a doctor by name or speciality...',
    },
};
